import type { Campaign } from '~/types/graphql';
import type { Variant } from '../types';

import { PROVIDER_GEMPAGES_DUPLICATE } from '~/constants/template';
import { useThemePageStore } from '~/stores/themePage';
import { parseTemplateInfoBy } from '~/utils';
import { findVariantByType } from '../utils';
import { IVariantType } from '../types';
import { useMemo } from 'react';

export const useGPVariantB = ({ campaigns }: { campaigns: Campaign[] }) => {
  const dataThemePages = useThemePageStore((state) => state.themePages);

  const checkIsGemPageTemplate = (campaign: Campaign, variantType: IVariantType) => {
    const variant = findVariantByType(campaign, variantType);
    const templateSuffix = variant?.templateSuffix;
    const templateInfo = parseTemplateInfoBy({ templateSuffix, themePages: dataThemePages });

    const isGPsTemplate =
      templateInfo?.providerSource &&
      PROVIDER_GEMPAGES_DUPLICATE.includes(templateInfo.providerSource);

    return isGPsTemplate;
  };

  const { variants, themePageIdsB } = useMemo(() => {
    const variants: Variant[] = [];
    const themePageIdsB: string[] = [];

    campaigns.forEach((campaign) => {
      campaign.variants?.forEach((variant) => {
        if (!checkIsGemPageTemplate(campaign, IVariantType.VARIANT_B)) {
          return;
        }

        if (variant?.themePageID && !variant?.isOrigin) {
          variants.push(variant);
          themePageIdsB.push(variant.themePageID);
        }
      });
    });

    return { variants, themePageIdsB };
  }, [campaigns]); //eslint-disable-line

  return { variants, themePageIdsB };
};
